<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte';
    import { _ } from 'svelte-i18n';
    import { get } from 'svelte/store';
    import { openModal } from 'svelte-modals';

    import ButtonAddSomething from '../../shared/ButtonAddSomething.svelte';
    import TemplateHeaderDuo from '../../shared/TemplateHeaderDuo.svelte';
    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import { MapPointLocation } from '../../utilities/MapPointLocation';
    import ConnectionEditForm from './ConnectionEditForm.svelte';
    import IconBack from '../../shared/Icons/IconBack.svelte';
    import { onMapReady } from '../../utilities/onMapReady';
    import { Connection } from './Connection';
    import { JobOnMap } from './JobOnMap';
    import { ConnectionApi } from './ConnectionApi';
    import { api } from '../../../stores/api';
    import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
    import { app } from '../../../stores/app';
    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import ModalError from '../../shared/Modals/ModalError.svelte';

    let connection: Connection = new Connection();
    let mapPointLocation: MapPointLocation | null = null;
    let dispatch = createEventDispatcher();
    let jobOnMap: JobOnMap = new JobOnMap();
    let jobGeocodedOnMap: JobOnMap = new JobOnMap();
    let triedToSave: boolean = false;

    let ready: boolean = false;
    let available: boolean = false;

    onMount(() => {
        Promise.all([
            onMapReady(),
            ConnectionApi.getCountWithQueries($api, {}, new ApiFilterBuilder(-1))
        ]).then((response) => {
            if ($app.settingsReadonly?.allow_limit_exceeding || (response[1]?.count || 0) < ($app.settingsReadonly?.max_connections || 0)) {
                mapPointLocation = new MapPointLocation();
                mapPointLocation.addEventListener('setCoordinates', function (evt: any) {
                    let x = evt.detail.coords.x;
                    let y = evt.detail.coords.y;
                    let balloonHtml = '-Adres-';
                    console.log('setcoordinates', { type: 'Point', coordinates: [x, y] });
                    // TODO: find nearest point
                });
                mapPointLocation.addEventListener('close', function () {
                    dispatch('pointonmapclose');
                });
                available = true;
            } else {
                openModal(ModalError, {
                    header: $_('Error'),
                    message: $_('max_connections_exceeded_manual'),
                    onClick: () => {
                        window.history.back();
                    }
                });
            }
            ready = true;
        });

        return () => {
            if (mapPointLocation) mapPointLocation.close(true);
        };
    });

    function startPointOnMap() {
        console.log('not implemented');
    }
</script>

<TemplateStandard>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderDuo>
            <div slot="main-header">
                <div style="display: flex; align-items: center;min-height: 36px;">
                    <IconBack
                        scale={0.7}
                        on:click={() => {
                            window.history.back();
                        }}
                    />
                    {$_('Manual add route')}
                </div>
            </div>
            <div slot="main-buttons" style="display:flex; align-items: center; column-gap: 25px;">
                <!--                <ButtonAddSomething-->
                <!--                    text={$_('Add job')}-->
                <!--                    on:click={() => {-->
                <!--                        connection = connection.setRequest({-->
                <!--                            location_id_from: null,-->
                <!--                            location_id_to: null,-->
                <!--                            is_ad_hoc: true,-->
                <!--                            note: '',-->
                <!--                        });-->
                <!--                    }}-->
                <!--                />-->
            </div>
        </TemplateHeaderDuo>
    </div>
    <div slot="content-header"></div>
    <div slot="content" style="display: flex; flex-direction: column; overflow-y: auto;">
        {#if ready}
            {#if available}
                <div style="flex: 1; display: flex; flex-direction: column; overflow-y: auto;">
                    <ConnectionEditForm
                        bind:connection
                        bind:jobOnMap
                        bind:jobGeocodedOnMap
                        bind:triedToSave
                        {startPointOnMap}
                    />
                </div>
            {/if}
        {:else}
            <div style="flex: 1; display: flex; align-items: center; justify-content: center;">
                <Spinner/>
            </div>
        {/if}
    </div>
    <div slot="footer"></div>
</TemplateStandard>

<style>
</style>
